import React, { useEffect, useState, useContext } from "react";

import SocketService from "../../../service/socket";
import RoomService from "../../../service/rooms-service";
import { AccountContext, UIStateContext } from "../../../provider";

import MobileView from "./mobile";
import WebView from "./web";
import Loading from "../../views/loading";
import Error from "../../views/error";

import { SCREEN_TYPE, STATUS } from "../../../constants";

export default ({ match }) => {
  const [status, setStatus] = useState(STATUS.LOADING);
  const [userInfo] = useContext(AccountContext);
  const [roomInfo, setRoomInfo] = useState(null);
  const [chats, setChats] = useState({ a: 6, msgs: ["Default welcome"] });

  const [UIState, setUIState] = useContext(UIStateContext);
  const { screen } = UIState;

  const fetchRoomInfo = async () => {
    const roomInfo = await RoomService.fetchRoom({ roomId: match.params.id });
    if (roomInfo) {
      setRoomInfo(roomInfo);
      setStatus(STATUS.SUCCESS);
    } else {
      setStatus(STATUS.ERROR);
    }
  };

  useEffect(() => {
    fetchRoomInfo();
  }, []);

  useEffect(() => {
    fetchRoomInfo();
    SocketService.setRefreshHandler(fetchRoomInfo);
  }, [match.params.id]);

  switch (status) {
    case STATUS.LOADING:
      return <Loading />;
    case STATUS.SUCCESS:
      return screen === SCREEN_TYPE.MOBILE ? (
        <MobileView roomInfo={roomInfo} refresh={fetchRoomInfo} />
      ) : (
        <WebView roomInfo={roomInfo} refresh={fetchRoomInfo} />
      );
    case STATUS.ERROR:
      return <Error message="Invalid Room id" />;
    default:
      return <Error message="Invalid Room id" />;
  }
};
